import { Row } from "./Row";

interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}


export const LinksToOtherPartiesWebsites = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title="Links to Other Parties' Websites"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Medcursor’s website may contain links to other websites of interest.
        However, once you have used these links to leave our site, you should
        note that we do not have any control over that other website. Therefore,
        we cannot be responsible for the protection and privacy of any
        information which you provide while visiting such sites and such sites
        are not governed by this policy. You should exercise caution and look at
        the privacy statement applicable to the website in question.
      </div>
    </Row>
  );
};
